<template>
    <ui-accordion-item v-on="$listeners" v-bind:model="model" v-bind:data-scope="model.type">
        <template v-slot:title="item">
            <div class="ui segment" v-bind:class="variant.background">
                <div class="ui header" v-bind:class="[variant.size, variant.color]">
                    <i v-if="!item.lock" class="site chevron icon" v-bind:class="{up: item.active, down: !item.active}"></i>
                    <fragment v-if="model.attributes.name">{{ $t(`scopes.${model.type}.title`, {identifier: model.attributes.name}) }}</fragment>
                    <fragment v-else>{{ $t(`scopes.${model.type}.title`, {identifier: ''}) }}</fragment>
                    <i v-if="!item.lock" class="white trash link icon" 
                        v-on:click.stop="onDeleteScope(model)" v-bind:class="deleteClass"></i>
                    <ui-progress v-bind:active="item.loading" variant="bottom attached"></ui-progress>
                </div>
            </div>
        </template>
        <template v-slot:content>
            <div class="ui segment">
                <div class="field">
                    <div class="two fields" v-for="(pair, index) in chunk(parameters, 2)" v-bind:key="index">
                        <div class="field" v-for="variable in pair" v-bind:key="variable.name"
                            v-bind:data-scope="model.type" v-bind:data-variable="variable.name">
                            <label>{{ $t(`scopes.${model.type}.variables.${variable.name}.label`, { currency }) }}</label>
                            <template v-if="isComposed(variable)">
                                <app-parameter v-bind:model="variable" :currency="currency" />
                            </template>
                            <template v-else>
                                <app-variable v-bind:model="variable" :currency="currency" />
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ui segment">
                <slot name="children" v-bind:scope="model"></slot>
            </div>
            <slot name="actions" v-bind:scope="model"></slot>
        </template>
    </ui-accordion-item>
</template>

<script>
import AppVariable from './AppVariable.vue'
import AppParameter from './AppParameter.vue'

import UiAccordionItem from './UiAccordionItem.vue'
import UiProgress from './UiProgress.vue'

export default {
    components: {
        AppParameter,
        AppVariable,
        UiAccordionItem,
        UiProgress
    },
    props: {
        default: Boolean,
        model: Object,
        variant: {
            type: Object,
            default() {
                return {
                    color: 'inverted',
                    background: 'dark blue',
                    size: ''
                }
            }
        },
        parentCurrency: {
            type: String,
            default: null,
        },
    },
    methods: {
        async onDeleteScope(model) {
            if (this.default) {
                return
            }

            try {
                await this.$modal(
                    'basic', 
                    {message: this.$t(
                        `scopes.${model.type}.actions.delete.confirm`, 
                        {identifier: model.attributes.name ? model.attributes.name : model.id}
                    )}
                )
                this.$store.dispatch('delete', model)
            } catch (e) {
                return
            }
        },
        chunk(array, size) {
            return Array(Math.ceil(array.length / size)).fill().map((a, i) => array.slice(i * size, i * size + size))
        },
        isComposed(variable) {
            return variable.schema.type === 'object'
        }
    },
    computed: {
        currency() {
            if (this.model.type === 'project') {
                return this.model.attributes.currency;
            }
            return this.parentCurrency;
        },
        schema() {
            return this.$store.state.definition[this.model.type]
        },
        parameters() {
            if (!this.model) {
                return []
            }

            const schema = this.schema.properties.attributes.properties

            const variables = Object.keys(schema).filter(
                name => schema[name]['x-variable'] 
                    && schema[name]['x-variable'].category === 'parameter'
                    && !this.$config.get(`scopes.${this.model.type}.variables.${name}.hidden`, false)
            ).map(name => {
                return {
                    name: name, 
                    context: this.model.attributes, 
                    schema: schema[name], 
                    scope: this.model
                }
            })

            return [{
                name: 'name', 
                context: this.model.attributes,
                schema: this.schema.properties.attributes.properties.name,
                scope: this.model
            }].concat(variables)
        },
        deleteClass() {
            return {
                disabled: this.default
            }
        },
        hasSlot() {
            return !!this.$slots.default
        }
    }
}
</script>